// import React, { useState } from "react";
// import "./SalesSummary.css";

// const SalesSummary = ({ salesData }) => {
//   const [activeTab, setActiveTab] = useState("plumbing");

//   return (
//     <div className="card border-0 sales-summary-card">
//       <div className="card-body">
//         <h4 className="card-title fw-semibold mb-4">
//           Sales Summary
//         </h4>

//         {/* Tabs */}
//         <div className="sales-tabs mb-3">
//           <button
//             className={`tab-btn ${activeTab === "plumbing" ? "active" : ""}`}
//             onClick={() => setActiveTab("plumbing")}
//           >
//             Plumbing
//           </button>

//           <button
//             className={`tab-btn ${activeTab === "bathware" ? "active" : ""}`}
//             onClick={() => setActiveTab("bathware")}
//           >
//             Bath ware & Others
//           </button>
//         </div>

//         {/* Tab Content */}
//         {activeTab === "plumbing" && (
//           <SalesCategorySummary data={salesData.plumbing} />
//         )}

//         {activeTab === "bathware" && (
//           <SalesCategorySummary data={salesData.bathware} />
//         )}
//       </div>
//     </div>
//   );
// };

// const SalesCategorySummary = ({ data }) => {
//   const formatCurrency = (value) =>
//     value?.toLocaleString("en-IN", {
//       style: "currency",
//       currency: "INR",
//     });

//   return (
//     <div className="row g-3">
//       <SummaryItem label="Month Target" value={formatCurrency(data.monthTarget)} />
//       <SummaryItem label="Month Achieved" value={formatCurrency(data.monthAchieved)} />
//       <SummaryItem label="Annual Target" value={formatCurrency(data.annualTarget)} />
//       <SummaryItem label="Annual Achieved" value={formatCurrency(data.annualAchieved)} />
//       <SummaryItem label="Open Order Value" value={formatCurrency(data.openOrderValue)} />
//     </div>
//   );
// };

// const SummaryItem = ({ label, value }) => (
//   <div className="col-12">
//     <div className="d-flex justify-content-between align-items-center p-2 bg-light rounded">
//       <span className="ss-label">{label}</span>
//       <span className="ss-value">{value}</span>
//     </div>
//   </div>
// );

// export default SalesSummary;

import React, { useState } from "react";
import "./SalesSummary.css";

const SalesSummary = () => {
  const [activeTab, setActiveTab] = useState("plumbing");

  const salesData = {
    plumbing: {
      monthTarget: 500000,
      monthAchieved: 325000,
      annualTarget: 6000000,
      annualAchieved: 4100000,
      openOrderValue: 180000,
    },
    bathware: {
      monthTarget: 300000,
      monthAchieved: 210000,
      annualTarget: 4000000,
      annualAchieved: 2850000,
      openOrderValue: 120000,
    },
  };

  return (
    <div className="card border-0 sales-summary-card">
      <div className="card-body">
        <h5 className="card-title fw-semibold mb-5">
          Sales Summary
        </h5>

        {/* Tabs */}
        <div className="sales-tabs mb-4">
          <button
            className={`tab-btn ${activeTab === "plumbing" ? "active" : ""}`}
            onClick={() => setActiveTab("plumbing")}
          >
            Plumbing
          </button>

          <button
            className={`tab-btn ${activeTab === "bathware" ? "active" : ""}`}
            onClick={() => setActiveTab("bathware")}
          >
            Bath ware & Others
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === "plumbing" && (
          <SalesCategorySummary data={salesData.plumbing} />
        )}

        {activeTab === "bathware" && (
          <SalesCategorySummary data={salesData.bathware} />
        )}
      </div>
    </div>
  );
};

const SalesCategorySummary = ({ data }) => {
  const formatCurrency = (value) =>
    value?.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    });

  return (
    <div className="row g-4 mt-3">
      <SummaryItem className="summary-item" label="Month Target" value={formatCurrency(data.monthTarget)} />
      <SummaryItem className="summary-item" label="Month Achieved" value={formatCurrency(data.monthAchieved)} />
      <SummaryItem className="summary-item" label="Annual Target" value={formatCurrency(data.annualTarget)} />
      <SummaryItem className="summary-item" label="Annual Achieved" value={formatCurrency(data.annualAchieved)} />
      <SummaryItem className="summary-item" label="Open Order Value" value={formatCurrency(data.openOrderValue)} />
    </div>
  );
};

const SummaryItem = ({ label, value }) => (
  <div className="col-12">
    <div className="d-flex justify-content-between align-items-center p-2 bg-light rounded">
      <span className="ss-label">{label}</span>
      <span className="ss-value">{value}</span>
    </div>
  </div>
);

export default SalesSummary;
